<script>
import { Line } from "vue-chartjs";
import clone from "lodash-es/clone";
export default {
  extends: Line,
  props: {
    dataForChart: {
      type: Array,
      default: () => [],
    },
    type: { type: String },
  },
  data() {
    return {
      label: [],
      statisticRevenue: [],
      statisticCountOrder: [],
      gradient: null,
    };
  },
  methods: {
    generateDataWithMonth() {
      let currentMonth = new Date().getMonth();
      let currentYear = new Date().getFullYear();
      let listMonths = [...Array(6)].map(() => {
        let month = currentMonth + 1;
        if (month === 12) currentYear--;
        if (month === 1) {
          currentMonth = 11;
        } else {
          currentMonth--;
        }

        return `${month}/${currentYear}`;
      });
      return listMonths;
    },
    setDataRevenue(data) {
      this.statisticRevenue = [];
      this.statisticCountOrder = [];
      this.label = [];
      let sortedData = data.sort((a, b) => {
        let firstDate = new Date(`${b._id.month}/01/${b._id.year}`);
        let secondDate = new Date(`${a._id.month}/01/${a._id.year}`);
        return firstDate - secondDate;
      });
      let genMonths = this.generateDataWithMonth();
      this.label = genMonths.reverse();
      this.label.map((monthOfYear) => {
        let existedData = sortedData.find(
          (data) => `${data._id.month}/${data._id.year}` === monthOfYear
        );
        this.statisticRevenue.push(existedData ? existedData.totalPrice / 1000 : 0);
        this.statisticCountOrder.push(existedData ? existedData.count : 0);
      });
      this.refresh();
    },
    refresh() {
      if (this.$refs.canvas) {
        this.gradient = this.$refs.canvas
          .getContext("2d")
          .createLinearGradient(0, 0, 0, 450);
        this.gradient.addColorStop(0, "#255cc2");
        this.gradient.addColorStop(0.5, "#3c73d9");
        this.gradient.addColorStop(1, "#ffffff");
        let priceDataSet = {
          label: this.$vuetify.lang.t(
            "$vuetify.MANAGE_FINANCE.TEACHER_TRANSACTION_LIST.GRAPH_STATISTIC.LABEL_REVENUE"
          ),
          borderColor: "#2E4493",
          pointBackgroundColor: "white",
          borderWidth: 1,
          pointBorderColor: "#2E4493",
          tension: 0,
          backgroundColor: "rgba(0, 0, 0, 0)",
          data: this.statisticRevenue,
        };
        const quantityDataSet = {
          label: this.$vuetify.lang.t(
            "$vuetify.MANAGE_FINANCE.TEACHER_TRANSACTION_LIST.GRAPH_STATISTIC.LABEL_REGISTER_QUANTITY"
          ),
          borderColor: "#FF1D30",
          pointBackgroundColor: "white",
          borderWidth: 1,
          pointBorderColor: "#FF1D30",
          tension: 0,
          backgroundColor: "rgba(0, 0, 0, 0)",
          data: this.statisticCountOrder,
        };
        let dataset = [];
        dataset.push(this.type === "price" ? priceDataSet : quantityDataSet);
        this.renderChart(
          {
            labels: this.label,
            datasets: dataset,
          },
          {
            legend: {
              display: false,
            },
            responsive: true,
            maintainAspectRatio: false,
          }
        );
      }
    },
  },
  watch: {
    dataForChart: {
      handler(value) {
        if (value && value.length) {
          let cloneData = clone(value, true);
          this.setDataRevenue(cloneData);
        } else {
          this.statisticRevenue = [];
          this.statisticCountOrder = [];
          this.refresh();
        }
      },
    },
  },
};
</script>
